<template>
  <div v-if="promotionActive && promotionStartDateCheck && promotionEndDateCheck">
    <div
      class="absolute left-0 top-0 z-[2] flex items-center space-x-1.5 rounded-t rounded-br p-2 text-xs font-extrabold uppercase text-white"
      :class="[
        {
          'bg-[color:var(--color-primary-500)]': promotionType == 'Highlight',
        },
        {
          'bg-[color:var(--color-secondary-500)]': promotionType == 'New',
        },
        {
          'bg-[color:var(--color-sale-badge-bg)]': promotionType == 'Promotion',
        },
      ]"
    >
      {{ promotionText }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { getDynamicPropertyValue } from "@/core/utilities";
import type { Property } from "@/core/api/graphql/types";
import type { PropType } from "vue";

const props = defineProps({
  properties: {
    type: Object as PropType<Property[] | undefined>,
    required: true,
  },
});

const PROMOTION_ACTIVE_PROPERTY = "promotionactive_property";
const promotionActive = computed<boolean>(
  () => getDynamicPropertyValue(props.properties, PROMOTION_ACTIVE_PROPERTY) ?? false,
);

const PROMOTION_START_DATE_PROPERTY = "promotionstartdate_property";
const PROMOTION_END_DATE_PROPERTY = "promotionenddate_property";

const promotionStartDateCheck = computed<boolean>(() => {
  const startDateProperty: string | undefined = getDynamicPropertyValue<string>(
    props.properties,
    PROMOTION_START_DATE_PROPERTY,
  );
  const now = new Date();
  if (startDateProperty) {
    const target = new Date(startDateProperty);

    return now > target;
  } else {
    return true;
  }
});

const promotionEndDateCheck = computed<boolean>(() => {
  const endDateProperty: string | undefined = getDynamicPropertyValue<string>(
    props.properties,
    PROMOTION_END_DATE_PROPERTY,
  );

  const now = new Date();
  if (endDateProperty) {
    const target = new Date(endDateProperty);

    return target > now;
  } else {
    return true;
  }
});

const PROMOTION_TEXT_PROPERTY = "promotiontext_property";
const promotionText = computed<string>(() => getDynamicPropertyValue(props.properties, PROMOTION_TEXT_PROPERTY) ?? "");

const PROMOTION_TYPE_PROPERTY = "promotiontype_property";
const promotionType = computed<string>(() => getDynamicPropertyValue(props.properties, PROMOTION_TYPE_PROPERTY) ?? "");
</script>
